import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '~/shared/components/form/components/form-fields/input';
import { Form } from '~/shared/components/form/components/form/form';
import { useTranslation } from '~/shared/utils/translation';

const FormWrap = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    listStyle: 'none',
    paddingBlock: theme.space[3],
    textTransform: 'uppercase',

    zIndex: 1,
    background: theme.colors.white,
    form: {
        width: '100%',
    },
}));

const FormTitle = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes.lg,
    marginBottom: theme.space[3],
    fontWeight: theme.fontWeights.medium,
}));
export const ZipCodeSearch = ({
    setZipCode,
    zipCode,
}: {
    setZipCode: (code: string) => void;
    zipCode: string;
}) => {
    const { translate } = useTranslation();
    const methods = useForm();
    const watchZipCode = methods.watch('zipCode');

    useEffect(() => {
        if (watchZipCode && watchZipCode.trim().length === 4) {
            setZipCode(watchZipCode.trim());
        }
    }, [watchZipCode, setZipCode]);

    return (
        <FormWrap>
            <FormTitle>{translate('checkout.checkout.delivery.location')}</FormTitle>
            <Form methods={methods} onSubmit={() => false}>
                <Input
                    name="zipCode"
                    maxLength={4}
                    label={translate('forms.fields.form.postalcode')}
                    defaultValue={zipCode}
                    appendWhenValid={false}
                />
            </Form>
        </FormWrap>
    );
};
